import React from "react"
import {Modal, notification} from 'antd'
import GenerateResuls from "./GenerateResuls"
import {bulkGenerateOrderByIds} from "../../../../../services/api/3dApi"

const generateTemplate = async (ids) => {
    const payload = {
        ids,
    }

    const {data: response} = await bulkGenerateOrderByIds(payload)

    const {success, data, error} = response

    if (!success) {
        throw new Error(error)
    }

    return data
}

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Bạn chắc chắn tạo file in các orders được chọn ?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk() {
            const result = generateTemplate(ids)

            result.then(res => {
                if (res === true) {
                    notification.success({
                        message: 'Yêu cầu thành công',
                        description: 'Yêu cầu tạo file in thành công và đang xử lý file in.',
                        duration: 10
                    })
                    onReset()
                    onSuccess()
                }
                notification.success({
                    message: 'Kết quả',
                    description: <GenerateResuls data={res}/>,
                    duration: 10
                })
                onReset()
                onSuccess()
            }).catch(err => {
                notification.error({
                    message: 'Yêu cầu lỗi',
                    description: err.message,
                    duration: 5
                })
            })
        }
    })
}
